import { DocumentIcon, PencilSquareIcon } from "@/icons/solid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const PayrollInProgress = ({ profile }) => {
	return (
		<>
			<div
				className="block text-center bg-white"
				style={{ paddingTop: 80 }}
			>
				<div className="main">
					<h1 className="font-w700 text-center">{`Hey ${profile?.givenName || "User"}!`}</h1>
					<div
						className="item item-circle bg-primary"
						style={{ position: "relative", height: "12rem", width: "12rem", marginBottom: 10 }}
					>
						<DocumentIcon
							style={{
								postion: "absolute",
								height: "10rem",
								color: "white",
								right: "1rem",
								top: "1rem",
								marginTop: "1rem",
							}}
						/>
						<PencilSquareIcon
							style={{
								position: "absolute",
								height: "5rem",
								color: "#ea611c",
								right: "0rem",
								top: "6rem",
								background: "white",
								borderRadius: "5rem",
								padding: "0.5rem",
								marginTop: "1rem",
							}}
						/>
					</div>
					<h3 className="text-center">
						Your Advisor is currently working on this payroll, come back later...
					</h3>
					<div style={{ marginTop: 30 }}>
						<Link
							type="button"
							className="btn btn-default"
							to="/people"
						>
							Return to home
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		profile: state?.my?.profile,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollInProgress);
